export default __webpack_public_path__ + "static/media/phone_view.ea683f50.jpg";